import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DatatableClickEvent } from '@basis/angular-components';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { SelectItem } from 'primeng/primeng';
import { BaseStepComponent } from "../../../base/base-step.component";
import { ValidCpfORCnpj } from 'app/util/custom.validators';
import { Instrutor } from 'app/entity/instrutor.model';
import { AnexoInstrutor } from 'app/entity/curriculo-instrutor.models';
import { Situacoes } from 'app/entity/enumeraveis';

@Component({
    selector: 'gerenciamento-curso-etapa3',
    templateUrl: './gerenciamento-curso-etapa3.component.html',
})
export class CrudGerenciamentoCursoEtapa3Component extends BaseStepComponent {

    displayDialog: boolean = false;

    @Input() listaInstrutores: any[] = [];
    @Input() listaResumo: any[] = [];
    @Input() listaRelatores: any[];
    @Input() validateForm: any = false;
    @Output() validateFormChange = new EventEmitter<any>();
    @Output() emitResponse = new EventEmitter<any>();


    @Output() listaFormacaoInstrutorChange = new EventEmitter<any[]>();

    instrutor: Instrutor = new Instrutor();
    listaFormacaoAcademico: SelectItem[] = [];
    listaFormacaoAcademicoCompleto: SelectItem[] = [];
    listaCursos: SelectItem[] = [];
    listaCursosCompleto: SelectItem[] = [];
    uploadedFiles: any[] = [];
    listaFormacaoInstrutor: any[] = [];
    countListaArquivos: any[] = [];
    anexo_instrutor: AnexoInstrutor;
    isValid: boolean = false;
    stepObject: any;
    isCPF: boolean = true;
    isBuscou: boolean = false;
    @Output() uploadedFilesChange = new EventEmitter<any>();
    cpf: any;
    cadastrarInstrutor = this.formBuilder.group({
        instrutor: this.formBuilder.group({
            nome: [null, [Validators.required, Validators.maxLength(100)]],
            cpf: [null, [Validators.required, ValidCpfORCnpj, Validators.maxLength(20)]],
            passaporte: [null, [Validators.maxLength(100)]],
            id: [null],
            registro_profissional: [null],
            tipo_documento: [1, [Validators.required]],
        }),
        formacao_instrutor: this.formBuilder.group({
            id_area: [null, [Validators.required]],
            id_formacao_academica: [null, [Validators.required]],
            curso: [null, [Validators.required, Validators.maxLength(255)]],
            id_instrutor: [null],
        }),
        anexo_instrutor: this.formBuilder.group({
            id_anexo: [null, [Validators.required]],
            id_instrutor: [null, [Validators.required]],
            id: [null]
        })
    });
    setStepObject(obj: any) {
        this.stepObject = obj;
    }

    init() {
        setTimeout(() => this.validateFormChange.emit(false), 0);

        // CARREGAR LISTA CURSO/AREA
        this.service.ListarTodos('cursoAcademico').subscribe(data => {
            this.listaCursosCompleto = data;
            this.listaCursos = data.filter(a => a.id_situacao == Situacoes.Ativo);
        })
        // CARREGAR LISTA DE FORMAÇÃO ACADEMICA
        this.service.ListarTodos('formacao-academica').subscribe(data => {
            this.listaFormacaoAcademicoCompleto = data;
            this.listaFormacaoAcademico = data.filter(a => a.id_situacao == Situacoes.Ativo);
        });
    }

    finalizar(event: any) {        
        this.isValid = false;
        this.validateForm = [this.cadastrarInstrutor.get('instrutor')];
        if (this.listaFormacaoInstrutor.length == 0) {
            this.showMsgWarn(`<p>É obrigatório ao menos uma formação acadêmica.</p>`);
            return
        }
        if (this.uploadedFiles.length == 0) {
            this.showMsgWarn(`<p>O anexo de arquivos é obrigatório.<br><br> Todos os comprovantes deverão ser anexados de uma só vez.</p>`);
            return
        }

        this.instrutor.anexo_instrutor = [];
        if (this.cadastrarInstrutor.get('instrutor.tipo_documento').value == 1)
            this.instrutor.cpf_passaporte = this.limpaCaracterEspecial(this.cadastrarInstrutor.value.instrutor.cpf);
        else
            this.instrutor.cpf_passaporte = this.limpaCaracterEspecial(this.cadastrarInstrutor.value.instrutor.passaporte);

        this.instrutor.registro_profissional = this.cadastrarInstrutor.value.instrutor.registro_profissional;
        this.instrutor.nome = this.cadastrarInstrutor.get('instrutor.nome').value;
        this.instrutor.id = this.cadastrarInstrutor.value.instrutor.id;
        this.instrutor.tipo_documento = this.cadastrarInstrutor.get('instrutor.tipo_documento').value;

        this.instrutor.anexo_instrutor = [];
        this.stepObject.uploadedFiles.forEach(item => {
            this.instrutor.anexo_instrutor.push(item);
        });

        this.instrutor.formacao_academica_instrutor = this.stepObject.listaFormacaoInstrutor.map(item => {
            item.id_instrutor = this.instrutor.id;
            return item;
        });
        this.confirmacao.confirm({
            header: 'Mensagem de Confirmação',
            message: `Atenção! Ao confirmar esta operação, você estará cadastrando um novo instrutor.<br>Deseja realmente confirmar esta operação?`,
            accept: () => {
                this.observableUtilPanelDoc.setBlockedPanel(true);
                this.service.Adicionar(`instrutor`, this.instrutor).subscribe(data => {
                    super.showMsgSucess("Sucesso ao salvar instrutor.");
                },

                    err => {
                        super.showMsgError(`Erro ao tentar salvar novo instrutor. ${err._body}`)
                    }, () => {
                        this.observableUtilPanelDoc.setBlockedPanel(false);
                        this.service.ListarInstrutores('instrutor').subscribe(data => {
                            this.listaInstrutores = data;
                        });
                        this.displayDialog = false;
                    }
                );
            }
        });
    }
}


// WEBPACK FOOTER //
// ./src/app/gerenciamento-curso/crud/etapas/gerenciamento-curso-etapa3.component.ts